import { primaryColors } from '@assets/styles/helpers/colors.styles'
import CircularProgress from '@mui/material/CircularProgress'

interface LoaderProps {
  size: 'small' | 'medium' | 'large'
}

function Loader(props: LoaderProps) {
  const { size } = props
  const sizeValue = (() => {
    switch (size) {
      case 'small':
        return 20
      case 'medium':
        return 40
      case 'large':
        return 64
      default:
        return 40
    }
  })()

  return (
    <CircularProgress
      sx={{
        width: `${sizeValue}px !important`,
        height: `${sizeValue}px !important`,
        color: primaryColors.orange
      }}
    />
  )
}

export default Loader
